import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const subtractIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 12.2V11H5V12.2H19Z" fill="currentColor" />
    </svg>
)

const SubtractIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {subtractIconSvg}
    </SvgIcon>
)

export default SubtractIcon